import UserModel from "src/models/UserModel";

export function getMissingAgreements(args: {
  account: UserModel;
  agreements: {
    id: string;
    availableForAllOfferings?: boolean;
    enabledByDefault?: boolean;
    title: string;
  }[];
}) {
  const hasGroupRegistrations =
    args.account?.activeGroupRegistrations.length > 0;
  const hasPrivateSeries = args.account?.activePrivateSeries.length > 0;
  const hasMemberships = args.account?.activeMemberships.length > 0;

  const missingAgreements =
    (hasGroupRegistrations || hasMemberships || hasPrivateSeries) &&
    args.agreements.filter((a) => {
      const hasntSigned = !args.account?.userAgreements?.find(
        (ua) => ua?.agreement?.id === a.id
      );

      const isApplicableGroup = args.account?.activeGroupRegistrations?.find(
        (gr) => gr.class?.agreements.find((ca) => ca.id === a.id)
      );
      const isApplicablePrivate = args.account?.activePrivateSeries?.find(
        (ps) => ps.offering?.agreements.find((oa) => oa.id === a.id)
      );
      const isApplicableMembership = args.account?.activeMemberships?.find(
        (m) => m.offering?.agreements.find((oa) => oa.id === a.id)
      );
      const isGlobal = a.availableForAllOfferings && a.enabledByDefault;

      return (
        hasntSigned &&
        (isApplicableGroup ||
          isApplicablePrivate ||
          isGlobal ||
          isApplicableMembership)
      );
    });

  return missingAgreements;
}
